import React, { Component } from 'react'
import _ from 'lodash'
import NetflixTray from '~/modules/Tray/Video/netflix-tray'
import { InstagramIcon } from '~/assets/svg'
import './index.scss'

class PersonDetail03 extends Component {
  state = {
    mobileMode: window.innerWidth <= 800
  }

  componentDidMount = () => {
    window.addEventListener('resize', () => {
      this.setState({ mobileMode: window.innerWidth <= 800 })
    }, false)
  }

  render() {
    const instructor = _.get(this.props, 'data.contentData[0].gist')
    const classes = _.get(instructor, 'relatedVideos', [])
    const isMobile = this.state.mobileMode
    const { 
      body, 
      instagramUrl, 
      facebookUrl, 
      twitterUrl,
      imageGist,
      badgeImages
    } = instructor
    return (
      <div 
        className="person-detail-03" 
        style={{ backgroundImage: `url(${isMobile ? imageGist._3x4 : imageGist._1x1})`}}
      >
        <div className="person-wrapper">
          <div className="instructor-logo">
            <img src={badgeImages._1x1} alt="brand logo" />
          </div>
          { isMobile && <div className="social-handles">
            { instagramUrl && <a href={instagramUrl} target="_blank">
                <InstagramIcon />
              </a> }
            { twitterUrl && <a href={twitterUrl} target="_blank">
              <i className="ion-social-twitter" />
            </a> }
            { facebookUrl && <a href={facebookUrl} target="_blank">
                <i className="ion-social-facebook" />
              </a> }
          </div> }
          <div className="info">
            <div className="description-wrapper">
              <div className="description" dangerouslySetInnerHTML={{ __html: body }} />
              <div className="classes">
                <NetflixTray 
                  settings={{
                    arrows: !isMobile,
                    swipe: !isMobile
                  }}
                  data={{
                    contentData: classes.filter(c => !c.gist.isLiveStream),
                    title: 'Recent classes'
                  }} 
                  layout={{
                    settings: {
                      thumbnailType: 'landscape', 
                      loop: false, 
                      columns: { 
                        desktop: 3,
                        mobile: 1,
                        ott: 4,
                        tablet: 2
                      }
                    }
                  }} 
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PersonDetail03